import { Component, Input, OnChanges } from '@angular/core';
import {AemUtil} from "@app/utils/aem.util";
import {ThirdpartyDocumentsAemItem} from "@app/models/aem.model";

@Component({
  selector: 'app-step-indicator',
  templateUrl: './step-indicator.component.html',
  styleUrls: ['./step-indicator.component.scss'],
  standalone: false,
})

export class StepIndicatorComponent implements OnChanges{
  @Input() thirdpartyDocumentsAemContent: ThirdpartyDocumentsAemItem;
  stepLabels: string[];
  @Input() currentStep: number;

  ngOnChanges() {
    this.stepLabels = AemUtil.getStepLabelsFromAem(this.thirdpartyDocumentsAemContent);
  }
}
